import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{staticClass:"mx-auto overflow-hidden",attrs:{"flat":"","tile":""}},[_c(VToolbar,{attrs:{"color":"#042333","dark":""}},[_c(VAppBarNavIcon,{attrs:{"color":"white"},on:{"click":function($event){return _vm.SET_DRAWER(true)}}}),_c(VToolbarTitle,{staticClass:"titulo-empresa",on:{"click":function($event){return _vm.LINK_PARAMETRIZACAO()}}},[_c('img',{staticClass:"img-empresa-header",attrs:{"src":_vm.empresa.logo_header,"width":"230"}})])],1)],1),_c('NavigationDrawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }